import React, { useState, useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import AuthLayout from './auth/AuthLayout';
import { API_BASE_URL } from '../App';
import './LoginPage.css';

function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';

  const [loading, setLoading] = useState(!!token);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!token) {
      setError('This verification link is missing or invalid.');
      setLoading(false);
      return;
    }

    fetch(`${API_BASE_URL}/sessions/verify-email`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token }),
    })
      .then(async (res) => {
        const data = await res.json().catch(() => ({}));
        if (!res.ok) {
          setError(data.error || 'Verification failed');
          return;
        }
        setMessage(data.message || 'Email verified. You can sign in now.');
      })
      .catch((e) => setError(e.message || 'Network error'))
      .finally(() => setLoading(false));
  }, [token]);

  return (
    <AuthLayout
      title="Verify your email"
      subtitle={
        loading
          ? 'Confirming your email address…'
          : error
            ? 'Something went wrong'
            : 'You\'re all set'
      }
    >
      {loading && <p className="auth-form__status" role="status">Please wait…</p>}

      {error && (
        <p className="auth-form__error" role="alert">
          {error}
        </p>
      )}

      {message && (
        <p className="auth-form__status auth-form__status--ok" role="status">
          {message}
        </p>
      )}

      {!loading && (
        <p className="auth-form__links">
          <Link to="/login">Go to sign in</Link>
        </p>
      )}
    </AuthLayout>
  );
}

export default VerifyEmailPage;
